import React from "react";
import useStore from "src/v2/utils/store";
import CustomButton from "../../form-components/custom-button";

export default function NewSimulationButton() {
  const setSimulationNameInputModal = useStore((s) => s.setSimulationNameInputModal);

  return (
    <CustomButton
      onClick={() => setSimulationNameInputModal(true)}
      style={{ width: "auto" }}
    >
      Create new simulation
    </CustomButton>
  );
}